import { gray } from '@carbon/colors';
import type { Expression } from 'mapbox-gl';
import type { RejectedPlace } from './coverage-preview';

// A place the TC team rejected: neutral grey (Carbon gray 50), not the not-valued orange. Their
// verdict, not a coverage gap anyone has to close.
export const REJECTED = gray[50];
/** The LTD tile's feature property the case map matches places on. */
export const LTD_PROPERTY = 'insights_unit_formation_slot_id';
/** The rejected places' layers, which the tooltip listens on. */
export const REJECTED_LAYER_IDS = [
  'case-slot-ltd-rejected-stick',
  'case-slot-ltd-rejected-point',
];

/**
 * The LTD tile filter for the rejected places, by IUFS row id.
 *
 * @param {Array} places - The rejected places.
 * @return {Expression} The layer filter.
 */
export const rejectedFilter = (
  places: readonly RejectedPlace[]
): Expression => [
  'in',
  ['get', LTD_PROPERTY],
  ['literal', places.map((place) => place.iufsId)],
];
